<template>
  <template v-if="normalizedOutput.length">
    <template v-for="(data, index) in normalizedOutput" :key="index">
      <tr class="summary-details">
        <td colspan="2">
          {{ $t("wholesaler.dashboard.overview.all") }}
          {{ $t("contact.form.tires").toLocaleLowerCase() }}
          {{ data.year }}
        </td>
        <td colspan="2">
          {{ data.yearly_sum }}
        </td>
      </tr>
      <tr class="summary-details">
        <td colspan="2">
          {{ $t("kickback.title") }} {{ data.year }}
        </td>
        <td colspan="2">
          &euro; {{ displayKickbacks ? formatFee(data.kick_back_fee) : "0,00" }}
        </td>
      </tr>
    </template>
  </template>

  <tr class="summary-details">
    <td colspan="2">{{ $t("tyreBox.target") }} {{ currentYear }}</td>
    <td colspan="2">
      <div v-if="userGoal">
        {{ $t(`multiplicator.goals.${userGoal.name}`) }} min.
        {{ userGoal.min_tyres }} {{ $t("tyreBox.title").toLocaleLowerCase() }}
      </div>
      <div v-if="userGoal">
        <span v-html="$t(`multiplicator.multiplication`, { factor: userGoal.factor })"></span>
      </div>
    </td>
  </tr>
</template>

<script setup>
import { computed, defineProps } from "vue";

const props = defineProps({
  bonusData: {
    type: Object,
    default: null,
  },
  currentYear: {
    type: Number,
    required: true,
  },
  userBonusMultiplicatorId: {
    type: Number,
    default: null,
  },
  output: {
    type: Array,
    default: () => [],
  },
  displayKickbacks: {
    type: Boolean,
    default: false,
  },
  isNlTenant: {
    type: Boolean,
    default: false,
  },
});

const userGoal = computed(() => {
  const goals = props.bonusData?.bonusGoals;
  if (!Array.isArray(goals) || props.userBonusMultiplicatorId == null) {
    return null;
  }
  return goals.find((bonus) => bonus.id === props.userBonusMultiplicatorId) || null;
});

const normalizedOutput = computed(() => {
  if (Array.isArray(props.output)) {
    return props.output;
  }
  if (props.output && typeof props.output === "object") {
    return Object.values(props.output);
  }
  return [];
});

const formatFee = (value) => (value ?? 0).toFixed(2).replace(".", ",");
</script>

<style scoped lang="scss">
@import "@/styles/_variables.scss";
@import "@/styles/points_overview.scss";

.nl-points-score-title {
  color: #000;
  font-size: 21px;
}
</style>
